/* tslint:disable */

declare var Object: any;
export interface FeatureFlagInterface {
  "name": string;
  "active": boolean;
  "activationData"?: any;
  "id"?: any;
}

export class FeatureFlag implements FeatureFlagInterface {
  "name": string;
  "active": boolean;
  "activationData": any;
  "id": any;
  constructor(data?: FeatureFlagInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FeatureFlag`.
   */
  public static getModelName() {
    return "FeatureFlag";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FeatureFlag for dynamic purposes.
  **/
  public static factory(data: FeatureFlagInterface): FeatureFlag{
    return new FeatureFlag(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FeatureFlag',
      plural: 'FeatureFlags',
      path: 'FeatureFlags',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "activationData": {
          name: 'activationData',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
